// extracted by mini-css-extract-plugin
module.exports = {"toggle":"FAQ_toggle__ShlUn","active":"FAQ_active__Kmku5"};